import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {KontakteKundenPage} from "../kontakte-kunden/kontakte-kunden";

/**
 * Generated class for the KontaktePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kontakte',
  templateUrl: 'kontakte.html',
})
export class KontaktePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad KontaktePage');
  }

  public openPageKontaktListe(type: number): void {
    if(type === 1){
      this.navCtrl.push(KontakteKundenPage, {type: 1})
    }
    if(type === 2){
      this.navCtrl.push(KontakteKundenPage, {type: 2})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/kontakte/kontakte.ts